<!-- 商品模块 -->
<template>
	<div class="index-product" :style="{backgroundColor:proData.bg_color,padding:proData.list_style=='4'?'0':'20px 3% 0'}">
		<div v-for="(pro,index) in proData.product" :key="index" :class="proData.list_style == '4'?'tab-detail':'tab-detail-'+proData.list_style" @click="goProductDtl(pro.product_info.id)">
			<template v-if="proData.list_style == '4'">
				<div class="fui-goods-item">
					<div v-if="proData.label_show == 0">
						<div class="goodsImg" :style="{backgroundImage:'url('+pro.product_info.image_url+')'}"></div>
					</div>
					<div v-else>
						<div v-if="proData.label_type == 1" class="goodsImg triangle" data-text="推荐" :style="{backgroundImage:'url('+pro.product_info.image_url+')'}"></div>
						<div v-else-if="proData.label_type == 2" class="goodsImg triangle" data-text="热销" :style="{backgroundImage:'url('+pro.product_info.image_url+')'}"></div>
						<div v-else-if="proData.label_type == 3" class="goodsImg triangle" data-text="上新" :style="{backgroundImage:'url('+pro.product_info.image_url+')'}"></div>
						<div v-else-if="proData.label_type == 4" class="goodsImg triangle" data-text="包邮" :style="{backgroundImage:'url('+pro.product_info.image_url+')'}"></div>
						<div v-else-if="proData.label_type == 5" class="goodsImg triangle" data-text="限时卖" :style="{backgroundImage:'url('+pro.product_info.image_url+')'}"></div>
						<div v-else-if="proData.label_type == 6" class="goodsImg triangle" data-text="促销" :style="{backgroundImage:'url('+pro.product_info.image_url+')'}"></div>
					</div>
					<div class="detail">
						<div class="product-item">
							<!-- 标签类型1推荐2热销3新上4包邮5限时卖6促销 -->
							{{pro.product_info.title}}
						</div>
						<div class="index_price price">
							<div v-if="pro.product_info.sales">
								<span class="text">￥{{pro.product_info.sales_price}}</span>
								<span class="oldPrice">￥{{pro.product_info.price}}</span>
							</div>
							<div v-else>
								<span class="text">￥{{pro.product_info.price}}</span>
							</div>
							<!-- <div class="stockNum"><span>库存</span>{{pro.product_info.stock}}</div> -->
							<div class="stockNum">{{pro.product_info.stock}}</div>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div class='product-item'>
					<el-image
						style="width: 100%;"
						class="product-proImg"
						:src="pro.product_info.image_url"
						fit="contain">
					</el-image>
					<div class="product-info">
						<div class="textline1">
							{{pro.product_info.title}}
						</div>
						<div class="index_price price">
							<div v-if="pro.product_info.sales">
								<span class="text">￥{{pro.product_info.sales_price}}</span>
								<span class="oldPrice">￥{{pro.product_info.price}}</span>
							</div>
							<div v-else>
								<span class="text">￥{{pro.product_info.price}}</span>
							</div>
							<div class="stockNum">{{pro.product_info.stock}}</div>
						</div>
					</div>
				</div>
			</template>
		</div>
		
	</div>
</template>
<script>
export default {
	name:'product',
	props:{
		proData:{
			type:Object,
		},
	},
	data () {
		return {

		}
	},
	watch: {

	},
	methods:{
		goProductDtl(id){
			console.log(id);
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/mode/product.vue